import 'angular:locale/data:el';
import 'angular:locale/data:en';
import 'zone.js';
import '@angular/compiler';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
